import { orchestrator } from 'satcheljs';
import { onOpenAppPane } from 'owa-app-pane-group-actions';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { getHostHub } from 'owa-config/lib/getHostHub';
import { isHostedCalendar } from 'owa-config/lib/isHostedCalendar';
import { TEAMS_HUB } from 'owa-config/lib/types/HostApp';
import openAppPane from './openAppPane';

orchestrator(onOpenAppPane, ({ appPaneName, targetWindow }) => {
    if (appPaneName === 'myDay' && isHostedCalendar() && getHostHub() === TEAMS_HUB) {
        return;
    }

    openAppPane(getDrawerPaneId(appPaneName), targetWindow);
});
